import { useMemo } from 'react'
import type { ContestItem } from 'src/services/orpc/contest'
import { useListContests } from 'src/services/orpc/contest'
import { getNodesFromConnection } from 'src/utils/graphql'
import { useQs } from 'src/utils/qs'

export interface HandledContest extends ContestItem {
  isEnded: boolean
  isInProgress: boolean
}

export const isContestEnded = (contest: Pick<ContestItem, 'endAt'>) => {
  return new Date(contest.endAt).getTime() <= new Date().getTime()
}

export const isContestInProgress = (
  contest: Pick<ContestItem, 'startAt' | 'endAt'>,
) => {
  return (
    new Date().getTime() >= new Date(contest.startAt).valueOf() &&
    !isContestEnded(contest)
  )
}

export const useContestConfig = () => {
  const { data: contestData } = useListContests({ last: 5 })

  const [{ preview }] = useQs()
  const contests = useMemo(
    () => getNodesFromConnection(contestData),
    [contestData],
  )

  const handledContests = useMemo(() => {
    return contests.map(c => ({
      ...c,
      isEnded: isContestEnded(c),
      isInProgress: isContestInProgress(c),
    }))
  }, [contests, preview])

  return handledContests
}
